import { Component } from '@angular/core';
import { AmplifyApiService } from './services/amplify-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'AKlor Software, LLC';

  constructor(
    private amplify: AmplifyApiService,
  ) {}
}
